import { RouterModule, Routes } from '@angular/router';
import { ViewExpensesComponent } from './components/view-expenses/view-expenses.component';
import { ListExpensesComponent } from './components/list-expenses/list-expenses.component';
import { ViewExpectedExpensesComponent } from './components/view-expected-expenses/view-expected-expenses.component';
import { ListExpectedExpensesComponent } from './components/list-expected-expenses/list-expected-expenses.component';





export const ExpensesRouter: Routes = [
    { path: 'create', component: ViewExpensesComponent},
    { path: 'view/:id', component: ViewExpensesComponent},
    { path: 'list', component: ListExpensesComponent },
    { path: 'expected/create', component: ViewExpectedExpensesComponent},
    { path: 'expected/view/:id', component: ViewExpectedExpensesComponent},
    { path: 'expected/list', component: ListExpectedExpensesComponent }
];


// WEBPACK FOOTER //
// ./src/app/expenses/expenses.router.ts